import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/shared-core/services/app-config.service';

@Component({
  selector: 'app-footer-copyright',
  templateUrl: './footer-copyright.component.html',
  styleUrls: ['./footer-copyright.component.scss'],
})
export class FooterCopyrightComponent {
  public year = new Date().getFullYear();
  public version = '';

  constructor(private _appConfigService: AppConfigService) {
    this.version = this._appConfigService.appVersion;
  }
}
